import { ArrowDownward, FileDownload } from '@mui/icons-material'
import { Box, Button, LinearProgress } from '@mui/material'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'

export const SearchTable = ({ id, pagination, setPagination, totalRecordCount, showTableLoading, showTable, columns, tableData, handleExportData, style, isEnableGlobalFilter = false, globalFilter = {}, setGlobalFilter = {} }) => {


    const table = useMaterialReactTable({
        columns,
        data: tableData,
        enableStickyHeader: true,
        positionGlobalFilter: 'right',
        // manualFiltering: false,
        enableGlobalFilter: isEnableGlobalFilter,
        onGlobalFilterChange: setGlobalFilter,
        showHideFilters: false,
        // enableTopToolbar: true,
        enableColumnFilter: false,
        enableHiding: true, //this shows the hide/ show columns
        // enableFullScreenToggle: true,
        enableColumnActions: false,
        enableDensityToggle: false,
        //  enableFilters: false, //this shows the search icon and filter icon together
        enableColumnFilters: false, //this hides the column filter
        muiSearchTextFieldProps: {
            placeholder: `Search by hardware SKU`,
            sx: { minWidth: '300px' },
            variant: 'outlined',
        },
        muiTableContainerProps: { sx: { maxHeight: '400px' } },
        initialState: {
            // columnVisibility: { action: false },
            columnPinning: { left: ['registration_id'], right: ['action'] },
            density: 'comfortable',
        },
        muiTableHeadCellProps: {
            align: 'center',
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                backgroundColor: '#1976d2',
                color: 'white',
                fontSize: '14px',
                verticalAlign: 'middle',
            },
        },
        muiColumnActionsButtonProps: ({ column, table }) => (<ArrowDownward />),
        muiTableBodyCellProps: {
            align: 'center',
            sx: {
                borderRight: '1px solid #e0e0e0',
                verticalAlign: 'middle',
            }
        },

        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={() => handleExportData(table?.getVisibleFlatColumns())}
                    startIcon={<FileDownload />}
                >
                    Export CSV
                </Button>
            </Box>
        ),
        manualPagination: true,
        onPaginationChange: setPagination,
        paginationDisplayMode: 'pages',
        rowCount: totalRecordCount, //should be the total records coming from response
        muiPaginationProps: {
            showRowsPerPage: false,
            shape: 'rounded',
            showFirstButton: true,
            showLastButton: true,
        },
        state: {
            pagination,
            globalFilter
        },

    });
    return (
        <div id={id || "search_table"} style={{ marginTop: 25, ...style }}>
            {showTableLoading && <LinearProgress />}
            {showTable &&
                <MaterialReactTable
                    table={table}
                />}
        </div>
    )
}
